import { createRouter, createWebHistory } from 'vue-router'

const Index = () => import(/* webpackChunkName: "index" */ '../views/IndexComponent.vue')
const AboutComponent = () => import(/* webpackChunkName: "about" */ '@/views/AboutComponent.vue')
const ContactComponent = () => import(/* webpackChunkName: "contact" */ '@/views/ContactComponent.vue')
const FaqComponent = () => import(/* webpackChunkName: "faq" */ '@/views/FaqComponent.vue')
const ServiceComponent = () => import(/* webpackChunkName: "service" */ '@/views/ServiceComponent.vue')
const DigitalOperationsManagementComponent = () => import(/* webpackChunkName: "dom" */ '@/views/DigitalOperationsManagementComponent.vue')
const ServiceFormComponent = () => import(/* webpackChunkName: "service-form" */ '@/views/ServiceFormComponent.vue')
const DigitalSalesComponent = () => import(/* webpackChunkName: "digital-sales" */ '@/views/DigitalSalesComponent.vue')
const SupportImprovementComponent = () => import(/* webpackChunkName: "support" */ '@/views/SupportImprovementComponent.vue')
const BrandingIdentityComponent = () => import(/* webpackChunkName: "branding" */ '@/views/BrandingIdentityComponent.vue')
const PrivacyPolicyComponent = () => import(/* webpackChunkName: "privacy" */ '@/views/PrivacyPolicyComponent.vue')
const PortfolioComponent = () => import(/* webpackChunkName: "portfolio" */ '@/views/PortfolioComponent.vue')
const BlogComponent = () => import(/* webpackChunkName: "blog" */ '@/views/BlogComponent.vue')
const BlogPostSignalsComponent = () => import(/* webpackChunkName: "blog-signals" */ '@/views/BlogPostSignalsComponent.vue')
const BlogPostStoreComponent = () => import(/* webpackChunkName: "blog-store" */ '@/views/BlogPostStoreComponent.vue')
const BlogPostLogoComponent = () => import(/* webpackChunkName: "blog-logo" */ '@/views/BlogPostLogoComponent.vue')
const BlogPostWebsiteComponent = () => import(/* webpackChunkName: "blog-website" */ '@/views/BlogPostWebsiteComponent.vue')
const LandingPrototypeComponent = () => import(/* webpackChunkName: "landing-prototype" */ '@/views/LandingPrototypeComponent.vue')
const NotFoundComponent = () => import(/* webpackChunkName: "not-found" */ '@/views/NotFoundComponent.vue')

// Define las rutas de la aplicación
const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/nosotros',
    alias: '/about',
    name: 'About',
    component: AboutComponent
  },
  {
    path: '/contacto',
    alias: '/contact',
    name: 'Contact',
    component: ContactComponent
  },
  {
    path: '/servicios',
    alias: '/services',
    name: 'Services',
    component: ServiceComponent
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: FaqComponent
  },
  {
    path: '/servicios/diseno-paginas-web',
    alias: '/services/web-design',
    name: 'DigitalOperationsManagement',
    component: DigitalOperationsManagementComponent
  },
  {
    path: '/servicios/tiendas-en-linea',
    alias: '/services/online-stores',
    name: 'DigitalSales',
    component: DigitalSalesComponent
  },
  {
    path: '/servicios/soporte-aplicaciones',
    alias: '/services/application-support',
    name: 'SupportOptimization',
    component: SupportImprovementComponent
  },
  {
    path: '/servicios/branding-identidad-marca',
    alias: '/services/branding-brand-identity',
    name: 'BrandingIdentity',
    component: BrandingIdentityComponent
  },
  {
    path: '/servicios/diseno-paginas-web/formulario',
    alias: '/services/web-design/form',
    name: 'ServiceFormDOM',
    component: ServiceFormComponent,
    meta: { formTitle: 'Solicitud: Diseño de Páginas Web | Raptoris' }
  },
  {
    path: '/servicios/tiendas-en-linea/formulario',
    alias: '/services/online-stores/form',
    name: 'ServiceFormSales',
    component: ServiceFormComponent,
    meta: { formTitle: 'Solicitud: Tienda en Línea | Raptoris' }
  },
  {
    path: '/servicios/soporte-aplicaciones/formulario',
    alias: '/services/application-support/form',
    name: 'ServiceFormSupport',
    component: ServiceFormComponent,
    meta: { formTitle: 'Solicitud: Soporte de Aplicaciones | Raptoris' }
  },
  {
    path: '/servicios/branding-identidad-marca/formulario',
    alias: '/services/branding-brand-identity/form',
    name: 'ServiceFormBranding',
    component: ServiceFormComponent,
    meta: { formTitle: 'Solicitud: Branding e Identidad de Marca | Raptoris' }
  },
  {
    path: '/aviso-privacidad',
    alias: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyComponent
  },
  {
    path: '/portafolio',
    alias: '/portfolio',
    name: 'Portfolio',
    component: PortfolioComponent
  },
  {
    // Prototipo: 6 posts de prueba, sin CMS detrás. Noindex hasta que haya
    // contenido real (ver BlogComponent.vue).
    path: '/blog',
    name: 'Blog',
    component: BlogComponent
  },
  {
    // Único post escrito por ahora (los otros 5 del listado son de prueba).
    // Sí es indexable: contenido real, a diferencia del listado.
    path: '/blog/5-senales-sitio-web-clientes',
    alias: '/blog/website-warning-signs-losing-customers',
    name: 'BlogSignals',
    component: BlogPostSignalsComponent
  },
  {
    // Post real de post1 (tienda en línea). Reemplaza al link que tenía
    // post1 hacia BlogSignals; ese artículo queda sin enlazar desde el
    // listado pero se conserva la ruta (ya podría estar indexada).
    path: '/blog/cuanto-cuesta-tienda-en-linea-mexico',
    alias: '/blog/online-store-cost-mexico',
    name: 'BlogStoreCost',
    component: BlogPostStoreComponent
  },
  {
    // Post real de post2 (logo e identidad de marca).
    path: '/blog/cuanto-cuesta-logo-identidad-marca-mexico',
    alias: '/blog/logo-brand-identity-cost-mexico',
    name: 'BlogLogoCost',
    component: BlogPostLogoComponent
  },
  {
    // Post real de post3 (sitio web 2026).
    path: '/blog/cuanto-cuesta-sitio-web-2026',
    alias: '/blog/website-cost-2026',
    name: 'BlogWebsiteCost',
    component: BlogPostWebsiteComponent
  },
  {
    // Prototipo de estructura tipo "landing de venta" (referencia: artismamkt.com).
    // No está en el navbar ni en el sitemap a propósito: es material para
    // revisar antes de decidir si algo se integra al home real.
    path: '/landing',
    name: 'LandingPrototype',
    component: LandingPrototypeComponent
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundComponent
  }
]

// Crea una instancia del enrutador con el historial en modo "history"
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router